import ipfs from 'decentralized/Ipfs.js';
import {NewPluginVersion, PluginCreated} from "decentralized/EthereumEvents.js"
import BackendQuery from "decentralized/BackendQuery.js";
import PluginsContract from "decentralized/contracts/PluginsContract.js";
import {ipfsHashToBytes32} from 'utils/ipfsHash';
import EthereumTransaction from "decentralized/transactions/EthereumTransaction.js";
import {PLUGINS} from "decentralized/transactions/contracts.js";

const contract = new PluginsContract();

export const createPlugin = async (
    json,
    name,
    description,
    thumbnail,
    {creatorShare, ownerShare, minterShare}
) => {
    console.log("JSON = ", json);
    let contentHash = await ipfs.addJson(json);
    // create URI
    let uri = "https://zequencer.io/ipfs/" + contentHash;

    const metadataJSON = JSON.stringify({
        description: description,
        mimeType: 'text/json',
        image: "https://zequencer.io/ipfs/" + thumbnail,
        name: name
    });

    let metadataURI = await ipfs.addBuffer(Buffer.from(metadataJSON));
    let args =         [
            name,
            uri,
            metadataURI,
            ipfsHashToBytes32(contentHash),
            [
                creatorShare,
                ownerShare,
                minterShare
            ]
    ];
    console.log(args);
    
    let transaction = new EthereumTransaction(
        PLUGINS, 'createPlugin', args);

    transaction.execute();
};


export const updatePlugin = async (
    json,
    name, 
    description,
    thumbnail,
    tokenId
) => {
    let contentHash = await ipfs.addJson(json);

    // create URI
    let uri = "https://zequencer.io/ipfs/" + contentHash;

    const metadataJSON = JSON.stringify({
        description: description,
        mimeType: 'text/json',
        image: "https://zequencer.io/ipfs/" + thumbnail,
        name: name
    });

    let metadataURI = await ipfs.addBuffer(Buffer.from(metadataJSON));

    let transaction = new EthereumTransaction(
        PLUGINS, 'updatePlugin', [
            tokenId,
            uri,
            metadataURI,
            ipfsHashToBytes32(contentHash)
        ]);

    transaction.execute();
}

export const getPlugins = async () => {
    let query = new BackendQuery(contract.contractAddress)
        .from(PluginCreated);

    let r = await query.executeQuery();
    let tokenIds = r.map(x => x.tokenId || 0);
    
    let versionsQuery = new BackendQuery(contract.contractAddress)
        .from(NewPluginVersion)
        .whereIn("tokenId", tokenIds);

    let versions = await versionsQuery.executeQuery();
    for (let version of versions) {
        let tokenId = version.tokenId;
        let result = r.find(x => x.tokenId === tokenId);
        if (result.tokenId === null) {
            result.tokenId = 0;
        }
        if (!result.versions) {
            result.versions = [];
        }
        result.versions.push(version);
    }
    return r;
};
